import diamond from "../images/diamond.webp";
import aaa1 from "./Portfolio_details/aaa1.webp";
import aaa2 from "./Portfolio_details/aaa2.webp";
import aaa3 from "./Portfolio_details/aaa3.webp";
import aaa4 from "./Portfolio_details/aaa4.webp";
import aaa5 from "./Portfolio_details/aaa5.jpg";
import aaa6 from "./Portfolio_details/aaa6.jpg";
import aaa7i from "./Portfolio_details/aaa7i.jpg";
import aaa7ii from "./Portfolio_details/aaa7ii.jpg";
import aaa8 from "./Portfolio_details/aaa8.webp";
import aaa9 from "./Portfolio_details/aaa9.webp";
import aaa10 from "./Portfolio_details/aaa10.webp";
import c1 from "./Portfolio_details/c1.webp";
import c2 from "./Portfolio_details/c2.webp";
import c3 from "./Portfolio_details/c3.webp";
import ccc1 from "./Portfolio_details/ccc1.jpg";
import ccc2 from "./Portfolio_details/ccc2.webp";
import ccc3 from "./Portfolio_details/ccc3.webp";
import ccc4 from "./Portfolio_details/ccc4.webp";
import ccc5 from "./Portfolio_details/ccc5.jpg";
import ccc6 from "./Portfolio_details/ccc6.jpg";
import ccc7i from "./Portfolio_details/ccc7i.jpg";
import ccc7ii from "./Portfolio_details/ccc7ii.jpg";
import ccc8 from "./Portfolio_details/ccc8.png";
import ccc9 from "./Portfolio_details/ccc9.webp";
import ccc10 from "./Portfolio_details/ccc10.jpg";
import ddd1 from "./Portfolio_details/ddd1.webp";
import ddd2i from "./Portfolio_details/ddd2i.jpg";
import ddd2ii from "./Portfolio_details/ddd2ii.jpg";
import ddd3 from "./Portfolio_details/ddd3.webp";
import ddd4 from "./Portfolio_details/ddd4.webp";
import ddd5 from "./Portfolio_details/ddd5.webp";
import ddd6 from "./Portfolio_details/ddd6.webp";
import ddd7 from "./Portfolio_details/ddd7.jpg";
import r1 from "./Portfolio_details/r1.webp";
import r2 from "./Portfolio_details/r2.webp";
import r3 from "./Portfolio_details/r3.webp";
import rrr1 from "./Portfolio_details/rrr1.webp";
import rrr2 from "./Portfolio_details/rrr2.webp";
import rrr3 from "./Portfolio_details/rrr3.webp";
import rrr4 from "./Portfolio_details/rrr4.webp";
import rrr5 from "./Portfolio_details/rrr5.webp";
import rrr6 from "./Portfolio_details/rrr6.webp";
import rrr7 from "./Portfolio_details/rrr7.jpg";
import rrr8i from "./Portfolio_details/rrr8i.jpg";
import rrr8ii from "./Portfolio_details/rrr8ii.jpg";
import rrr9 from "./Portfolio_details/rrr9.webp";
import rrr10 from "./Portfolio_details/rrr10.jpg";
import eee1 from "./Portfolio_details/eee1.webp";
import eee2 from "./Portfolio_details/eee2.webp";
import eee3 from "./Portfolio_details/eee3.webp";
import e4 from "./Portfolio_details/e4.webp";
import e4i from "./Portfolio_details/e4i.webp";
import e4ii from "./Portfolio_details/e4ii.webp";
import e4iii from "./Portfolio_details/e4iii.webp";
import eee4i from "./Portfolio_details/eee4i.webp";
import eee6 from "./Portfolio_details/eee6.webp";
import eee7 from "./Portfolio_details/eee7.webp";
import eee8 from "./Portfolio_details/eee8.webp";
import eee9 from "./Portfolio_details/eee9.webp";
import eee10 from "./Portfolio_details/eee10.webp";
import t1 from "./Portfolio_details/t1.webp";
import t2 from "./Portfolio_details/t2.webp";
import t3 from "./Portfolio_details/t3.webp";
import t4 from "./Portfolio_details/t4.webp";
import t5 from "./Portfolio_details/t5.webp";
import ttt1 from "./Portfolio_details/ttt1.webp";
import ttt2i from "./Portfolio_details/ttt2i.webp";
import ttt2ii from "./Portfolio_details/ttt2ii.webp";
import ttt3 from "./Portfolio_details/ttt3.webp";
import ttt4 from "./Portfolio_details/ttt4.webp";
import ttt5 from "./Portfolio_details/ttt5.webp";
import ttt6 from "./Portfolio_details/ttt6.jpg";

export const portfolioStories = [
  {
    slug: "revolutionizing-ecommerce",
    title: "Revolutionizing eCommerce",
    image: diamond,
    description:
      "Unifying systems and enhancing customer experiences for Diamonds Direct",
    services: ["AI/ML", "TRANSFORMATION", "MODERNIZATION"],
    team: ["Thomas Riberio", "Sihye Ryu", "Ricairis Tejada", "Viraj Upadhyay"],
    heroTitle: "Diamonds Direct",
    heroDescription:
      "We reimagined the disconnected digital landscape at Diamonds Direct with a modern experience platform designed to deliver a polished luxury journey across every customer touchpoint.",
    status: "published",
    detail: {
      coverImage: rrr1,
      sectionNav: [
        { id: "overview", label: "Overview" },
        { id: "services", label: "Services" },
        { id: "how-we-did-it", label: "How we did it" },
        { id: "impact", label: "Impact" },
      ],
      overviewServices: [
        {
          label: "Data Analytics",
          path: "/data-services-details",
        },
        {
          label: "Generative AI",
          path: "/generative-ai-details",
        },
        {
          label: "Software Engineering",
          path: "/software-engineering-details",
        },
        {
          label: "Commerce Acceleration",
          path: "/services",
        },
      ],
      overview: [
        "Diamonds Direct is a luxury jewelry retailer based in Charlotte, North Carolina, with more than twenty locations across the United States and a strong online business supporting its in-store presence.",
        "As customer expectations became more digital, the brand was held back by disconnected systems and aging technology that made it harder to unify data, simplify operations, and create the refined, personalized experience shoppers expect from a premium retailer.",
        "Zedflux partnered with the business to bring its digital ecosystem together, connect its technology stack, reduce manual overhead, and create a more consistent, insight-driven customer experience worthy of the brand.",
      ],
      overviewHeading:
        "Bringing a luxury jewelry brand onto a more connected digital foundation",
      overviewGallery: [rrr2, rrr3],
      servicesCopy: [
        "To strengthen Diamonds Direct's digital foundation and support long-term growth, Zedflux introduced a set of scalable solutions centered on personalization, speed, and operational efficiency.",
        "We implemented a modern headless content workflow that made storefront updates faster and easier, helping the brand keep product storytelling, campaigns, and merchandising fresh without unnecessary bottlenecks.",
        "At the same time, we unified customer information and decisioning layers so the business could act on real-time insight, sharpen engagement strategies, and deliver a luxury shopping experience that feels more responsive across channels.",
      ],
      servicesHeading:
        "Modernizing content, customer intelligence, and luxury commerce delivery",
      servicesFeatureBlock: {
        title: "Omnichannel Experiences Platform",
        body: "Diamonds Direct needed a way to move beyond fragmented systems and outdated software. Zedflux created a modular experience platform that connected legacy tools with third-party services inside one cohesive operating layer. That shift reduced manual effort, surfaced live business insight, and gave the brand the flexibility to respond faster to evolving customer behavior and market needs.",
        image: rrr4,
        imagePosition: "left",
      },
      coreHighlightsTitle: "Core Highlights",
      coreHighlightsImages: [r1, r2, r3],
      howWeDidItIntro:
        "Zedflux combined modern content operations, customer intelligence, and platform engineering to help Diamonds Direct deliver a faster, more unified luxury commerce experience.",
      howWeDidItHeading:
        "Connecting systems, content, and customer insight into one luxury experience layer",
      contentBlocks: [
        {
          type: "text",
          title: "Next-gen Content Management System",
          body: "By rolling out Experro as a headless CMS, we gave the Diamonds Direct team far more control over digital content. Marketing pages, product narratives, promotions, and storefront updates could all move faster, allowing the brand to stay agile without relying on developer time for every change.",
        },
        {
          type: "imageText",
          title: "Personalized Customer Experiences",
          body: "Zedflux designed AI-driven models that bring together signals from web activity, chat, email, text, in-store interactions, and other customer touchpoints. With that connected view, Diamonds Direct can power better recommendations, smarter search, stronger merchandising decisions, and a more tailored buying journey that lifts engagement, conversion, and average order value.",
          image: rrr5,
          imagePosition: "right",
        },
        {
          type: "imageText",
          title: "Enterprise Transformation",
          body: "The transformation program unified multiple technologies and service layers into a more efficient operating model. That consolidation improved automation, reduced manual work, lowered operational drag, and gave the business a fuller view of its customers. The result was a dramatically faster site experience and a stronger link between digital intelligence and in-store service.",
          image: rrr6,
          imagePosition: "left",
        },
        {
          type: "fullImage",
          image: rrr7,
          alt: "Diamonds Direct commerce platform visual",
        },
        {
          type: "gallery",
          images: [rrr8i, rrr8ii],
          altPrefix: "Diamonds Direct supporting visual",
        },
        {
          type: "quote",
          body: "With the support of Experro, we were able to expand our digital presence beyond expectations, creating more personalized journeys, stronger engagement, and greater flexibility across the full experience.",
        },
        {
          type: "fullImage",
          image: rrr9,
          alt: "Diamonds Direct storefront and experience visual",
        },
      ],
      impactCopy: [
        "Diamonds Direct now operates on a far stronger digital foundation, with the tools and insight needed to deliver a premium, data-informed customer experience across channels.",
        "The transformation produced clear business results while positioning the brand to continue leading in luxury jewelry through speed, personalization, and operational clarity.",
      ],
      impactHeading:
        "A stronger digital foundation for premium customer experiences and growth",
      impactStats: [
        { value: "205k", label: "Increase in traffic" },
        { value: "90%", label: "Improvement in performance" },
        { value: "30%", label: "Uplift in customer retention" },
        { value: "40%", label: "Growth in revenue" },
      ],
      impactImage: rrr10,
    },
  },
  {
    slug: "bespoke-b2b-sales-portal",
    title: "Bespoke B2B Sales Portal",
    video: "/porfolio/cadence-cover.mp4",
    description:
      "Transforming sales through a custom-built sales portal and ERP integration",
    services: ["DESIGN", "DEVOPS", "INNOVATION"],
    team: ["Maryam Ghafoori", "Jingya Wang"],
    heroTitle: "Cadence",
    heroDescription:
      "We modernized Cadence's sales operations with a purpose-built B2B portal that connects cleanly to legacy ERP infrastructure, keeps critical data in sync, and gives the sales team a faster mobile-friendly workflow.",
    status: "published",
    detail: {
      coverImage: ccc1,
      sectionNav: [
        { id: "overview", label: "Overview" },
        { id: "services", label: "Services" },
        { id: "how-we-did-it", label: "How we did it" },
        { id: "impact", label: "Impact" },
      ],
      overviewServices: [
        {
          label: "Data Analytics",
          path: "/data-services-details",
        },
        {
          label: "Generative AI",
          path: "/generative-ai-details",
        },
        {
          label: "Software Engineering",
          path: "/software-engineering-details",
        },
        {
          label: "Commerce Acceleration",
          path: "/services",
        },
      ],
      overview: [
        "Cadence is a major petroleum products distributor whose legacy ERP environment was slowing down order handling and creating friction across the sales process.",
        "While the underlying back-end systems remained powerful, the lack of a clear and intuitive sales interface forced representatives to work through overly complex workflows. That friction extended the sales cycle and made everyday execution less efficient than it should have been.",
        "Zedflux partnered with Cadence to redesign the digital sales experience, creating a custom B2B portal that connects directly to the ERP, surfaces live information, strengthens security, and better supports a modern field sales team.",
      ],
      overviewHeading:
        "Giving a legacy ERP environment a faster, more usable sales layer",
      overviewGallery: [ccc2, ccc3],
      servicesCopy: [
        "To modernize Cadence's sales operations, Zedflux delivered a focused transformation program that combined ERP analysis, integration engineering, and user-centered product design.",
        "Our work centered on making a complex system easier to use in the real world. That meant simplifying workflows, improving visibility, and creating a sales experience that helps teams act quickly instead of fighting the tooling behind the process.",
      ],
      servicesHeading:
        "Building a smarter B2B workflow around legacy systems and field sales needs",
      servicesFeatureBlock: {
        title: "Tailored B2B Sales Portal",
        body: "Zedflux designed and developed a custom B2B sales portal that changed how the Cadence sales team works day to day. Built around usability and speed, the portal removed much of the friction caused by the old ERP interface and made order handling more straightforward, allowing representatives to spend less time navigating systems and more time serving customers.",
        image: ccc4,
        imagePosition: "left",
      },
      coreHighlightsTitle: "Performance Milestones",
      coreHighlightsImages: [c1, c2, c3],
      howWeDidItIntro:
        "Zedflux approached the Cadence transformation as both a platform modernization effort and a field-sales productivity upgrade, balancing integration depth with usability, security, and speed.",
      howWeDidItHeading:
        "Connecting ERP complexity to a cleaner, more productive sales experience",
      contentBlocks: [
        {
          type: "text",
          title: "Seamless ERP Integration",
          body: "A deep understanding of Cadence's legacy ERP architecture was essential to the solution. Our team mapped the existing data structures and business logic, then built custom APIs that keep orders, inventory, and customer information synchronized in real time. That integration reduced manual re-entry, improved consistency, and removed the silos that had slowed the operation down.",
        },
        {
          type: "text",
          title: "Enterprise Security & SSO",
          body: "Security and access control were built in from the start. Zedflux introduced enterprise-grade protections, including single sign-on, so the sales team could move through the system with less friction while sensitive business data remained properly protected and governed.",
        },
        {
          type: "imageText",
          title: "Reimagined Sales Environment",
          body: "With a clear need to improve sales efficiency and better support the field team, Cadence worked with Zedflux to create a custom portal that links directly with its existing ERP. The result was a more intuitive operating environment with live visibility, cleaner workflows, stronger security, and a user experience better suited to mobile-first sales activity.",
          image: ccc5,
          imagePosition: "right",
        },
        {
          type: "imageText",
          title: "Mobile-optimized Sales Experience",
          body: "Because sales activity doesn't stop at a desk, Zedflux made sure the portal performs well across mobile devices. Representatives can review information, manage orders, and support customers while on the move, giving the team more flexibility and helping productivity stay high throughout the day.",
          image: ccc8,
          imagePosition: "right",
        },
        {
          type: "fullImage",
          image: ccc6,
          alt: "Cadence sales portal transformation visual",
        },
        {
          type: "gallery",
          images: [ccc7i, ccc7ii],
          altPrefix: "Cadence supporting visual",
        },
        {
          type: "quote",
          body: "Zedflux became our digital partner of choice when we needed a responsive, easy-to-use sales portal that could integrate with our new ERP. Their work helped us preserve visibility, productivity, and continuity during a critical transition period.",
        },
        {
          type: "fullImage",
          image: ccc9,
          alt: "Cadence mobile and portal experience visual",
        },
      ],
      impactCopy: [
        "The solution transformed Cadence's operations by simplifying workflows, connecting ERP data in real time, and making order processing more efficient from end to end.",
        "With centralized visibility and a mobile-ready interface, the sales team gained the clarity and speed needed to improve customer engagement while supporting stronger long-term growth.",
      ],
      impactHeading:
        "Sharper workflows, live ERP visibility, and a stronger sales operation",
      impactStats: [
        { value: "50%", label: "Reduction in order processing time" },
        { value: "360°", label: "View of sales and inventory" },
        { value: "45%", label: "Boost in operational efficiency" },
        { value: "70%", label: "Improved customer engagement" },
      ],
      impactImage: ccc10,
    },
  },
  {
    slug: "automated-invoice-processing",
    title: "Automated Invoice Processing",
    video: "/porfolio/automated-invoice.mp4",
    description: "Reducing manual tasks with machine learning models",
    services: ["AI/ML", "TRANSFORMATION", "INNOVATION"],
    team: ["Maryam Ghafoori", "Jingya Wang"],
    heroTitle: "Automated Invoice Processing",
    heroDescription:
      "We built an AI-driven invoice automation workflow for a major hardware manufacturer, reducing manual review by extracting and validating invoice data with far greater speed and accuracy.",
    status: "published",
    detail: {
      coverImage: aaa1,
      sectionNav: [
        { id: "overview", label: "Overview" },
        { id: "services", label: "Services" },
        { id: "how-we-did-it", label: "How we did it" },
        { id: "impact", label: "Impact" },
      ],
      overviewServices: [
        {
          label: "Data Analytics",
          path: "/data-services-details",
        },
        {
          label: "Generative AI",
          path: "/generative-ai-details",
        },
        {
          label: "Software Engineering",
          path: "/software-engineering-details",
        },
        {
          label: "Commerce Acceleration",
          path: "/services",
        },
      ],
      overview: [
        "Our client, a large U.S. manufacturer and distributor of hardware products, was dealing with a heavy stream of vendor invoices arriving in many different layouts and file structures.",
        "Every document had to be reviewed manually, checked against ERP records, and converted into payment requests. The process consumed valuable time, introduced avoidable mistakes, and slowed the pace of financial operations.",
        "Zedflux modernized that workflow with a purpose-built automation solution. Using machine learning and a custom form-recognition approach, we reduced manual effort, improved data quality, and accelerated invoice handling from intake through validation.",
      ],
      overviewHeading:
        "Replacing manual invoice handling with a faster, more intelligent workflow",
      overviewGallery: [aaa2, aaa3],
      servicesHeading:
        "Building an end-to-end AI workflow for invoice capture, validation, and delivery",
      servicesCopy: [
        "To transform invoice processing, Zedflux developed a full AI-powered pipeline that automates data capture, validation, and downstream integration across the invoicing lifecycle.",
        "By combining advanced machine learning with Microsoft Azure services, we converted inconsistent vendor forms into structured, high-confidence data that could move directly into business workflows with far less manual intervention.",
      ],
      servicesFeatureBlock: {
        title: "Data Ingestion & Transformation",
        body: "Zedflux applied modern AI techniques to process large volumes of vendor acknowledgment forms arriving by email. The solution extracts, cleans, and transforms the incoming information before loading it into Azure Data Lake, creating a dependable foundation for downstream models and analytics while improving consistency across records.",
        image: aaa4,
        imagePosition: "left",
      },
      coreHighlightsTitle: "Core Highlights",
      coreHighlightsImages: [aaa2, aaa3, aaa2, aaa3],
      howWeDidItIntro:
        "Zedflux treated invoice automation as both a machine-learning challenge and an operational efficiency opportunity, connecting extraction accuracy, validation logic, and delivery workflows into one practical system.",
      howWeDidItHeading:
        "From incoming vendor forms to validated payment-ready data",
      contentBlocks: [
        {
          type: "imageText",
          title: "Model Development",
          body: "Using Microsoft Azure Form Recognizer and custom configuration work, Zedflux built a tailored extraction layer capable of identifying critical invoice fields and assigning useful confidence scores. The models were shaped around the client's document patterns so the system could produce reliable outputs across a range of invoice formats.",
          image: aaa5,
          imagePosition: "right",
        },
        {
          type: "text",
          title: "Model Training",
          body: "We trained the solution on a substantial set of labeled forms and refined it iteratively to improve both speed and accuracy. The resulting model can now pull invoice information, compare it against ERP records, and support automated payment request generation with much less manual correction.",
        },
        {
          type: "fullImage",
          image: aaa6,
          alt: "Invoice automation model workflow visual",
        },
        {
          type: "gallery",
          images: [aaa7i, aaa7ii],
          altPrefix: "Invoice automation supporting visual",
        },
        {
          type: "imageText",
          title: "Application Delivery",
          body: "Deployed on Azure Databricks, the solution uses Azure Form Recognizer APIs to extract invoice data and confidence scores automatically. Structured outputs are prepared for business review in familiar formats such as Excel, while mismatches and low-confidence fields are surfaced clearly for fast resolution.",
          image: aaa8,
          imagePosition: "right",
        },
        {
          type: "fullImage",
          image: aaa9,
          alt: "Invoice processing delivery visual",
        },
      ],
      impactHeading:
        "A faster, more accurate invoicing process with less manual effort",
      impactCopy: [
        "The AI-powered workflow significantly reduced manual touchpoints, improved data precision, and accelerated invoice movement through the approval process.",
        "By making invoice handling more efficient and less error-prone, the solution created a more scalable and cost-effective finance operation with stronger business outcomes.",
      ],
      impactStats: [
        { value: "5x", label: "Faster invoice approvals" },
        { value: "80%", label: "Reduction in processing errors" },
        { value: "25%", label: "Lower operational costs" },
      ],
      impactImage: aaa10,
    },
  },
  {
    slug: "sales-efficiency-and-engagement",
    title: "Sales Efficiency and Engagement",
    video: "/porfolio/sale_efficiency.mp4",
    description: "Re-imagining cold outreach through Design Sprint",
    services: ["INNOVATION", "DESIGN", "STRATEGY"],
    team: ["Maryam Ghafoori", "Jingya Wang"],
    heroTitle: "Transforming LinkedIn Outreach",
    heroDescription:
      "We turned a messy LinkedIn outreach process into a more structured, CRM-connected workflow that helps sales teams move faster, reduce manual effort, and engage prospects with greater consistency.",
    status: "published",
    detail: {
      coverImage: ttt1,
      sectionNav: [
        { id: "overview", label: "Overview" },
        { id: "services", label: "Services" },
        { id: "how-we-did-it", label: "How we did it" },
        { id: "impact", label: "Impact" },
      ],
      overviewServices: [
        {
          label: "Data Analytics",
          path: "/data-services-details",
        },
        {
          label: "Generative AI",
          path: "/generative-ai-details",
        },
        {
          label: "Software Engineering",
          path: "/software-engineering-details",
        },
        {
          label: "Commerce Acceleration",
          path: "/services",
        },
      ],
      overviewHeading:
        "Reworking LinkedIn prospecting into a more reliable digital sales motion",
      overview: [
        "Salesmate, one of the fastest-growing technology and analytics companies in the United States, was struggling with the operational friction of managing LinkedIn connections at scale.",
        "Sales teams were burdened with manual follow-ups, weak response rates, and no dependable reminder system for approved connection requests. That made prospecting inconsistent and reduced the effectiveness of outbound engagement.",
        "Zedflux partnered with Salesmate to rethink the workflow from the ground up. Through an intensive five-day design sprint and tighter CRM integration, we designed a more disciplined outreach experience that supports stronger follow-through and better sales efficiency.",
      ],
      overviewGallery: [ttt2i, ttt2ii],
      servicesHeading:
        "Blending design sprint thinking with CRM-connected outreach automation",
      servicesCopy: [
        "To improve cold outreach performance, Zedflux designed a focused solution that combines structured design sprint practices with smooth CRM integration.",
        "The result was a clearer, more manageable LinkedIn connection workflow that reduces administrative overhead while helping sales teams act on opportunities with better timing and consistency.",
      ],
      servicesFeatureBlock: {
        title: "CRM & LinkedIn Integration",
        body: "We connected Salesmate's CRM with LinkedIn activity so connection tracking and follow-ups could happen with far less manual effort. Approved connections could be managed with better timing, more personalized engagement, and stronger accountability across the sales process.",
        image: ttt4,
        imagePosition: "left",
      },
      coreHighlightsTitle: "Step by Step Solution",
      coreHighlightsImages: [t1, t2, t3, t4, t5],
      howWeDidItHeading:
        "Using design sprint insight and workflow automation to strengthen outreach",
      howWeDidItIntro:
        "The first phase focused on uncovering the practical challenges sales teams faced when trying to manage LinkedIn connections. One of the clearest issues was the lack of reminders and follow-through after connection requests were approved.",
      contentBlocks: [
        {
          type: "text",
          title: "Automated Outreach Optimization",
          body: "By embedding automation into the outreach flow, Zedflux created a system that manages connections more efficiently and supports lead nurturing through smarter follow-up steps. This reduced repetitive manual work while making outreach feel more timely and more relevant.",
        },
        {
          type: "fullImage",
          image: ttt3,
          alt: "LinkedIn outreach workflow visual",
        },
        {
          type: "quote",
          body: "Zedflux designed and delivered an automated digital platform that helped us manage a complex outreach operation with far more control, visibility, and consistency. The result was a major improvement in efficiency, responsiveness, and day-to-day performance.",
        },
        {
          type: "imageText",
          title: "Collaborative Innovation Framework",
          body: "Our working model encouraged rapid learning and agile problem solving through practices such as How Might We sessions and assumption mapping. That framework helped ensure the solution was useful at launch while still leaving room for continuous refinement as outreach strategies evolved.",
          image: ttt4,
          imagePosition: "right",
        },
        {
          type: "fullImage",
          image: ttt5,
          alt: "Salesmate collaborative innovation visual",
        },
      ],
      impactHeading:
        "Higher-quality outreach with less manual effort and faster follow-through",
      impactCopy: [
        "The new solution reshaped how Salesmate approaches LinkedIn engagement, improving connection handling, reducing process overhead, and giving sales teams more room to focus on valuable conversations.",
        "By bringing outreach into a more structured and data-aware system, the team gained speed, consistency, and stronger foundations for growth.",
      ],
      impactStats: [
        { value: "80%", label: "Reduction in process timing" },
        { value: "90%", label: "Improvement in accuracy" },
        { value: "25%", label: "Savings on operational costs" },
      ],
      impactImage: ttt6,
    },
  },
  {
    slug: "ai-powered-personalization",
    title: "AI-Powered Personalization",
    video: "/porfolio/AI-Powered.mp4",
    description: "Enhancing eCommerce experiences",
    services: ["STRATEGY", "AI/ML", "COMMERCE"],
    team: ["Maryam Ghafoori", "Jingya Wang"],
    heroTitle: "Enhancing eCommerce Experiences",
    heroDescription:
      "Helping a major U.S. grocery retailer modernize digital shopping with intelligent recommendations and predictive decisioning for millions of daily customer interactions.",
    status: "published",
    detail: {
      coverImage: eee1,
      sectionNav: [
        { id: "overview", label: "Overview" },
        { id: "services", label: "Services" },
        { id: "how-we-did-it", label: "How we did it" },
        { id: "impact", label: "Impact" },
      ],
      overviewServices: [
        {
          label: "Data Analytics",
          path: "/data-services-details",
        },
        {
          label: "Generative AI",
          path: "/generative-ai-details",
        },
        {
          label: "Software Engineering",
          path: "/software-engineering-details",
        },
        {
          label: "Commerce Acceleration",
          path: "/services",
        },
      ],
      overview: [
        "A leading U.S. grocery business with thousands of stores across dozens of states needed its digital channels to feel as useful and intuitive as its physical footprint.",
        "Shoppers were not always seeing the right products at the right moment, which weakened engagement, reduced repeat purchases, and put loyalty at risk. The retailer had immense volumes of behavioral, customer, and transaction data, but it needed a better way to turn that information into relevant experiences across every channel.",
        "Zedflux stepped in to transform that data into practical intelligence, using advanced analytics and AI-led product thinking to make shopping faster, easier, and more personalized.",
      ],
      overviewHeading:
        "Turning enterprise-scale retail data into better shopping experiences",
      overviewGallery: [eee2, eee3],
      servicesCopy: [
        "Zedflux delivered an AI-enabled commerce solution built to improve product discovery and create a more responsive shopping journey. The work began with enterprise-scale data cleanup and the creation of a machine-learning foundation designed for retail complexity.",
        "Within a short delivery window, we launched a recommendation engine powered by collaborative and content-aware models. By learning from order patterns and customer behavior, the platform could surface live recommendations across more than 30 categories, including category standouts and trending products.",
        "We also upgraded search with natural language processing and machine-learning ranking, reducing dead-end searches and adding more helpful autocomplete behavior. On the operations side, we introduced inventory prediction models that blended reservations, pick activity, product velocity, seasonality, demand signals, and supply-chain inputs.",
      ],
      servicesHeading:
        "Building a recommendation and prediction engine for modern retail",
      coreHighlightsTitle: "Core Highlights",
      coreHighlightsImages: [e4, e4i, e4ii, e4iii],
      processSteps: [
        {
          title: "1. Personalized Recommendations",
          body: "After structuring and analyzing large-scale order and browsing data, Zedflux created a recommendation engine that used collaborative and content-aware modeling to match shoppers with products that fit their preferences, routines, and purchase intent.",
          image: eee4i,
          imagePosition: "right",
        },
        {
          title: "2. Product Listing Personalization",
          body: "Zedflux applied machine learning to live on-site behavior and contextual customer signals so product collections could be reordered around each shopper. The result was a more relevant category experience, supported by modules such as top picks and trending items that improved discovery and repeat engagement.",
          image: eee6,
          imagePosition: "left",
        },
        {
          title: "3. Dynamic Search Results",
          body: "Zedflux combined natural language processing, machine-learning ranking, and behavioral context to return more relevant search results in real time. Smarter autocomplete and fewer zero-result journeys made search feel more human and more effective for conversion.",
          image: eee7,
          imagePosition: "right",
        },
        {
          title: "4. Inventory Predictions",
          body: "To improve both fulfillment readiness and customer confidence, Zedflux built prediction models that brought together reservation patterns, picking activity, seasonal demand, product movement, forecasting data, and supply-chain signals. This gave the retailer a stronger view of stock risk while customers were still building baskets.",
          image: eee8,
          imagePosition: "left",
        },
      ],
      supportingImage: eee9,
      impactCopy: [
        "Zedflux combined product strategy, design thinking, data expertise, and engineering execution to move quickly from concept to a production-ready release plan.",
        "By pairing modern open-source technology with agile delivery practices, we created a durable platform for stronger retention, higher digital confidence, and long-term commerce growth.",
      ],
      impactHeading: "Fast execution, stronger engagement, measurable growth",
      impactStats: [
        { value: "10%", label: "Growth in daily orders" },
        { value: "1.5x", label: "Increase in customer loyalty" },
        { value: "30+", label: "Product categories analyzed" },
        { value: "1M+", label: "Customer records analyzed" },
      ],
      impactImage: eee10,
    },
  },
  {
    slug: "data-platform-for-real-time-insights",
    title: "Data Platform for Real-time insights",
    video: "/porfolio/Data.mp4",
    description: "Enabling data-backed decisions",
    services: ["INNOVATION", "ANALYTICS"],
    team: ["Maryam Ghafoori", "Jingya Wang"],
    heroTitle: "Data Platform for Real-time Insights",
    heroDescription:
      "We created a scalable data platform that connected more than thirty systems, turning fragmented operational data into real-time intelligence for a leading U.S. building materials manufacturer.",
    status: "published",
    detail: {
      coverImage: ddd1,
      sectionNav: [
        { id: "overview", label: "Overview" },
        { id: "services", label: "Services" },
        { id: "how-we-did-it", label: "How we did it" },
        { id: "impact", label: "Impact" },
      ],
      overviewServices: [
        {
          label: "Data Analytics",
          path: "/data-services-details",
        },
        {
          label: "Generative AI",
          path: "/generative-ai-details",
        },
        {
          label: "Software Engineering",
          path: "/software-engineering-details",
        },
        {
          label: "Commerce Acceleration",
          path: "/services",
        },
      ],
      overviewHeading:
        "Building a future-ready analytics backbone for growth through acquisition",
      overview: [
        "Our client is a well-established manufacturer and distributor in the U.S. construction market, operating dozens of distribution centers and more than twenty-five subsidiaries across the country.",
        "As the business accelerated its mergers and acquisitions strategy, it needed a platform that could absorb data from newly added companies quickly, turn that information into practical insight, and support better decisions across operations, sales, costs, and resource planning.",
        "Its existing warehouse environment was expensive to manage and not dependable enough for the level of visibility the organization required. Zedflux was brought in to rethink the data strategy, strengthen analytics capabilities, and build a more scalable warehousing foundation for continued growth.",
      ],
      overviewGallery: [ddd2i, ddd2ii],
      servicesHeading:
        "Redesigning analytics strategy, integration flows, and reporting foundations",
      servicesCopy: [
        "Zedflux partnered with the executive team to assess and modernize the organization's analytics capabilities from the ground up. The company wanted a stronger in-house data function while also relying on a strategic partner to help shape its long-term analytics direction.",
        "Working closely with leadership and alongside the existing BI vendor, we reviewed the current architecture, processes, tooling, and bottlenecks. That combination of business context and technical analysis allowed us to define a practical roadmap for a stronger enterprise data platform.",
      ],
      servicesFeatureBlock: {
        title: "Intelligent Data Integration & Optimization",
        body: "Together, we replaced rigid and difficult-to-scale data processes with a more resilient platform capable of ingesting and integrating information from multiple ERPs and third-party systems. Zedflux helped organize and enrich that data inside a flexible warehouse and connect it to reporting tools such as Power BI, improving reliability, cost efficiency, and delivery speed across analytics initiatives.",
        image: ddd3,
        imagePosition: "left",
      },
      howWeDidItHeading:
        "Turning disconnected systems into a real-time analytics operating layer",
      howWeDidItIntro:
        "The transformation centered on making enterprise data more usable, more trustworthy, and far easier to scale as the organization continued to grow through acquisitions.",
      contentBlocks: [
        {
          type: "text",
          title: "Enabled Data-driven Decision-making",
          body: "Zedflux delivered multiple Power BI applications tailored to engineering, operations, finance, and sales. These apps surfaced live dashboards, predictive analysis, and trend visibility that helped teams spot savings opportunities, allocate resources more effectively, and operate with better confidence and speed.",
        },
        {
          type: "imageText",
          title: "Scalable and Reliable Architecture",
          body: "We designed a future-ready architecture focused on availability, elasticity, and strong system performance. By using cloud-native services, automated ETL pipelines, and distributed data patterns, the platform could support growing data volumes and increasingly complex analytics workloads while keeping access secure and timely.",
          image: ddd4,

          imagePosition: "right",
        },
        {
          type: "quote",
          body: "Zedflux is our exclusive data and analytics partner. From strategy to analytics to AI and machine learning, we rely on them to connect our silos, surface intelligence, and automate complex operational work.",
        },
        {
          type: "imageText",
          title: "Smart Data Optimization & Process Automation",
          body: "Zedflux introduced a strong governance model with proactive monitoring, automated workflows, and AI-assisted anomaly detection to improve data consistency and trust. Real-time validation checks reduced errors before they reached reporting layers, while streamlined cleansing, transformation, and reporting flows lowered manual effort and strengthened self-service analytics across the business.",
          image: ddd5,
          imagePosition: "right",
        },
        {
          type: "fullImage",
          image: ddd6,
          alt: "Enterprise data platform architecture visual",
        },
      ],
      impactHeading:
        "A stronger analytics engine for growth, speed, and operational clarity",
      impactCopy: [
        "The new platform did more than improve analytics delivery. It reshaped how the organization uses data to support expansion, improve collaboration across departments, and make smarter decisions at scale.",
        "By breaking down data silos and creating a more resilient architecture, Zedflux positioned the client to keep innovating, improve operational performance, and maintain a stronger competitive position in its market.",
      ],
      impactStats: [
        { value: "7X", label: "Improvement in results delivery" },
        { value: "70%", label: "Reduced time to insights" },
        { value: "50%", label: "Reduced analytics costs" },
        { value: "25+", label: "Subsidiaries integrated" },
      ],
      impactImage: ddd7,
    },
  },
];

export function getPortfolioStoryBySlug(slug) {
  return portfolioStories.find((story) => story.slug === slug);
}
